import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {Observable} from 'rxjs';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/internal/operators/map';
import {filter} from 'rxjs/operators';

@Pipe({
    name: 'secureImg',
    standalone: false,
})

@Injectable()
export class SecureImgPipe implements PipeTransform {
    constructor(private http: HttpClient, private sanitizer: DomSanitizer) {
    }

    transform(url: string): Observable<{ url: SafeUrl, hasValue?: boolean }> {
        return this.http
            .get(url, {responseType: 'blob'})
            .pipe(
                filter((val: Blob) => !!val),
                map(val => {
                    return  {
                        url: this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val)),
                        hasValue: val.size > 0
                    };
                })
            );
    }
}
